import type { StackFrame } from '@sentry/nextjs';

type TExceptionMechanism = {
  type?: string;
  handled?: boolean;
};

const BROWSER_API_MECHANISM_PREFIX = 'auto.browser.browserapierrors.';

export function hasAppFrame(frames: StackFrame[]): boolean {
  return frames.some((frame) => (frame.filename ?? frame.abs_path ?? '').includes('/_next/'));
}

// Injected scripts normalize to app:/// or <anonymous>, leaving denyUrls no host to match on.
export function isThirdPartyScriptCrash(
  mechanism: TExceptionMechanism | undefined,
  frames: StackFrame[],
): boolean {
  if (mechanism?.handled !== false) {
    return false;
  }

  const mechanismType = mechanism.type ?? '';
  // browserApiErrors wraps setTimeout and friends, so a third-party callback misses onerror.
  const isUnhandledCallback =
    mechanismType.endsWith('onerror') || mechanismType.startsWith(BROWSER_API_MECHANISM_PREFIX);

  return isUnhandledCallback && frames.length > 0 && !hasAppFrame(frames);
}
